import actionTypes from 'SRC/modules/redux/actionTypes'

export const setIsGroupPage = (isGroupPage = false) => ({
  type: actionTypes.SET_IS_GROUP_PAGE,
  payload: isGroupPage
})
